<template>
  <div>
    <v-card>
      <v-toolbar flat color="white" class="pt-2  ma-4" >
        <v-toolbar-title>
          <v-icon class="mb-1">mdi-account-search</v-icon>
          Guias por Cliente
        </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>

        <v-container fluid class="pt-8 mt-4 mb-4">
          <v-row no-gutters>
            <v-col cols="2" class="pr-2">
              <v-text-field
                v-model="filtroAwb"
                label="Número de guía"
                clearable
                @keyup.enter="cargarLista()"
                dense
                class="mt-1"
              ></v-text-field>
            </v-col>
            <v-col cols="2" class="px-2">
              <v-text-field
                v-model="filtroDesde"
                type="date"
                label="Desde"
                clearable
                @change="cargarLista()"
                dense
                class="mt-1"
              ></v-text-field>
            </v-col>
            <v-col cols="2" class="px-2">
              <v-text-field
                v-model="filtroHasta"
                type="date"
                label="Hasta"
                clearable
                @change="cargarLista()"
                dense
                class="mt-1"
              ></v-text-field>
            </v-col>
            <v-col cols="2" class="px-2">
              <v-select
                v-model="filtroMedioTransporte"
                :items="mediosTransporte"
                item-text="NOMBRE"
                item-value="MEDIO"
                label="Medio"
                clearable
                @change="cargarLista()"
                dense
                class="mt-1"
              ></v-select>
            </v-col>
            <v-col cols="2" class="px-2">
              <v-select
                v-model="filtroEstado"
                :items="estados"
                item-text="NOMBRE"
                item-value="ESTADO_ID"
                label="Estado"
                clearable
                @change="cargarLista()"
                dense
                class="mt-1"
              ></v-select>
            </v-col>
            <v-col cols="1" class="text-left pl-2">
              <v-btn small color="primary" @click="cargarLista()" class="mt-2">
                <v-icon left>mdi-magnify</v-icon> Buscar
              </v-btn>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-n3 pt-2">
            <v-col cols="4" class="pr-4">
              <v-autocomplete
                v-model="filtroCliente"
                :items="clientes"
                item-text="CLI_NOMBRE"
                item-value="ENTE_ID"
                label="Cliente"
                clearable
                @change="cargarLista()"
                dense
                class="mt-1"
              ></v-autocomplete>
            </v-col>
            <v-col cols="4" class="pr-2">
              <v-autocomplete
                v-model="filtroAerolinea"
                :items="aerolineas"
                item-text="AEROLINEA_NOMBRE"
                item-value="AEROLINEA_ID"
                label="Aerolínea"
                clearable
                @change="cargarLista()"
                dense
                class="mt-1"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-container>
      </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="lista"
        :items-per-page="itemsPerPage"
        :options.sync="options"
        :loading="loadingTable"
        class="elevation-1"
      >
        <template v-slot:item.opcion="{ item }">
          <v-btn icon color="blue" @click="verDetalle(item)" title="Ver detalle">
            <v-icon>mdi-file-eye</v-icon>
          </v-btn>
          <v-btn icon color="orange" @click="abrirAlertas(item)" title="Alertas finca" :disabled="item.ESTADO !== 'CERRADA'">
            <v-icon>mdi-alert</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.AWB="{ item }">
          <strong>{{ item.AWB }}</strong>
        </template>
        <template v-slot:item.FECHA="{ item }">
          {{ item.FECHA ? item.FECHA.substring(0, 10) : '' }}
        </template>
        <template v-slot:footer>
          <v-pagination
            class="mt-10"
            v-model="currentPage"
            :length="pageCount"
            @input="handlePageChange"
            total-visible="10"
          ></v-pagination>
        </template>
      </v-data-table>
    </v-card>

    <DetalleGuiaHijas v-model="dialogDetalle" :awb="awbSeleccionado" />
    <AlertasFinca v-model="dialogAlertas" :awb="awbSeleccionado"  />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import DetalleGuiaHijas from "./DetalleGuiaHijas.vue";
import AlertasFinca from "./AlertasFinca.vue";

export default {
  name: "GuiasPorCliente",
  components: { DetalleGuiaHijas, AlertasFinca },
  data: () => ({
    headers: [
      { text: "Opciones", value: "opcion", sortable: false },
      { text: "AWB", value: "AWB" },
      { text: "Fecha", value: "FECHA" },
      { text: "Cliente", value: "CLIENTE_NOMBRE" },      
      { text: "Aerolínea", value: "AEROLINEA_NOMBRE" },
      { text: "Estado", value: "ESTADO" },
    ],
    lista: [],
    options: {},
    pageCount: 0,
    currentPage: 1,
    itemsPerPage: 40,

    filtroAwb: "",
    filtroDesde: "",
    filtroHasta: "",
    filtroCliente: null,
    filtroMedioTransporte: null,
    filtroAerolinea: null,
    filtroEstado: null,

    clientes: [],
    aerolineas: [],
    estados: [],
    mediosTransporte: [],

    dialogDetalle: false,
    dialogAlertas: false,
    awbSeleccionado: "",
  }),
  computed: {
    ...mapState("master", ["loadingTable", "user"]),
    ...mapGetters("access", [""]),
  },
  methods: {
    ...mapMutations("master", [
      "setUrl",
      "setLoadingTable",
      "setTitleToolbar",
    ]),
    ...mapActions("master", ["requestApi"]),

    cargarLista() {
      this.setLoadingTable(true);
      this.setUrl("api/guias-por-cliente");
      this.requestApi({
        method: "GET",
        data: {
          page: this.currentPage,
          itemsPerPage: this.itemsPerPage,
          awb: this.filtroAwb,
          desde: this.filtroDesde,
          hasta: this.filtroHasta,
          cliente_id: this.filtroCliente || "",
          medio_transporte: this.filtroMedioTransporte || "",
          aerolinea_id: this.filtroAerolinea || "",
          estado_id: this.filtroEstado || "",
          sortBy: this.options.sortBy ? this.options.sortBy[0] : null,
          sortDesc: this.options.sortDesc ? this.options.sortDesc[0] : null,
        },
      })
        .then((res) => {
          this.lista = res.data.lista;
          this.pageCount = res.data.pageCount;
        })
        .catch(() => {})
        .finally(() => {
          this.setLoadingTable(false);
        });
    },

    cargarDatosForm() {
      this.setUrl("api/form-guias-por-cliente");
      this.requestApi({ method: "GET", data: {} })
        .then((res) => {
          this.clientes = res.data.clientes || [];
          this.aerolineas = res.data.aerolineas || [];
          this.estados = res.data.estados || [];
          this.mediosTransporte = res.data.medios_transporte || [];
        })
        .catch(() => {});
    },

    verDetalle(item) {
      this.awbSeleccionado = item.AWB;
      this.dialogDetalle = true;
    },

    abrirAlertas(item) {
      this.awbSeleccionado = item.AWB;
      this.dialogAlertas = true;
    },

    handlePageChange() {
      this.cargarLista();
    },
  },
  mounted() {
    document.title = "Sistema de carga";
    this.setTitleToolbar("Guias por Cliente");
    this.cargarDatosForm();
    this.cargarLista();
  },
  watch: {
    options: {
      handler() {
        this.cargarLista();
      },
      deep: true,
    },
  },
};
</script>
